import React from 'react';

const SvgExternal = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 12 12" ref={svgRef} {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <defs>
      <path
        id="External_svg_a"
        d="M1243.667 589.667h-9.334v-9.334H1239V579h-4.667c-.74 0-1.333.6-1.333 1.333v9.334c0 .733.593 1.333 1.333 1.333h9.334c.733 0 1.333-.6 1.333-1.333V585h-1.333zM1240.333 579v1.333h2.394l-6.554 6.554.94.94 6.554-6.554v2.394H1245V579z"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#External_svg_a" transform="translate(-1233 -579)" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgExternal svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/External.js